exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Loader__Backdrop__1rIEG {\n    background-color: rgb(0,0,0,0.9);\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    display: none;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    z-index: 300;\n}\n\n.Loader__holder__3yNmn {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.Loader__Backdrop__1rIEG h2 {\n    width: 100%;\n    margin-bottom: 2rem;\n    color: white;\n    z-index: 400;\n}\n.Loader__Show__2nxsJ {\n    display: -ms-flexbox;\n    display: flex;\n}", ""]);

// exports
exports.locals = {
	"Backdrop": "Loader__Backdrop__1rIEG",
	"holder": "Loader__holder__3yNmn",
	"Show": "Loader__Show__2nxsJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/UI/Loader/Loader.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/UI/Loader/Loader.css
// module chunks = 0